import './AppSection.scss';
function AppSection(props){
    return(
        <div className="app-section-part">
            <div className="content">
                <h1>{props.title}</h1>
                <p>{props.desc}</p>
                <p>{props.desc2}</p>
                <p>{props.desc3}</p>
                <div className="others">
                    {props.btn1 ? props.btn1 : null}
                    {props.btn2 ? props.btn2 : null}

                </div>
            </div>
            <div className="image-part">
                <img src={props.image} />
            </div>
        </div>
    )
};
export default AppSection ;